module.exports = {
  headLine: `
    <p><span style="font-size: 42pt; color: #ffffff;"><strong><span style="font-family: 'Playfair Display';">Win Your Dream Experience</span></strong></span></p>
  `,
  details: `
    <ul>
    <li><span style="font-family: 'Plus Jakarta Sans'; font-size: 14pt; color: #1e293b;">$10,000 grand prize package</span></li>
    <li><span style="font-family: 'Plus Jakarta Sans'; font-size: 14pt; color: #1e293b;">VIP access to exclusive events</span></li>
    <li><span style="font-family: 'Plus Jakarta Sans'; font-size: 14pt; color: #1e293b;">Premium products worth $2,500</span></li>
    <li><span style="font-family: 'Plus Jakarta Sans'; font-size: 14pt; color: #1e293b;">Luxury accommodation for 2 people</span></li>
    <li><span style="font-family: 'Plus Jakarta Sans'; font-size: 14pt; color: #1e293b;">$2,000 travel credit</span></li>
    <li><span style="font-family: 'Plus Jakarta Sans'; font-size: 14pt; color: #1e293b;">Exclusive merchandise bundle</span></li>
    </ul>
  `,
  disclaimer:
    '<p><span style="font-size: 10pt;"><span style="font-family: \'Plus Jakarta Sans\'; color: #666666;">TERMS: NO PURCHASE NECESSARY. Purchasing does not improve your chance of winning. Void where prohibited. Sweepstakes is open to legal residents of 48 of the 50 US and DC (excluding Alaska, Hawaii, Puerto Rico, Canada, and US territories & possessions). Must be 18 years or older to enter. See official rules for complete details. Copyright © 2025 All Rights Reserved.</span></span></p>',
  mainImage: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4",
  entryButtonText: "ENTER TO WIN",
  scrollButtonText: "ENTER TO WIN",
  showScrollButton: true,
  preEntryMessage: `
    <p><span style="font-family: 'Plus Jakarta Sans'; font-size: 24pt; color: #f8fafc;">Experience the adventure of a lifetime with premium prizes and unforgettable memories.</span></p>
  `,
  detailsHeading: `
    <p><span style="font-family: 'Plus Jakarta Sans'; font-size: 24pt; color: #1e293b;">What You Can Win</span></p>
  `,
  landerVersion: "version-16",
  prizingPartnerText: "PRIZING PROVIDED BY",
  prizing_logo: null,
  inputs: {
    email: true,
    emailRequired: true,
    errors: {},
    firstName: true,
    firstNameRequired: true,
    lastName: true,
    lastNameRequired: true,
  },
  inputLabels: true,
  customFonts: { values: ["'Playfair Display'", "'Plus Jakarta Sans'", "'Poppins'"] },
  styles: {
    fonts: {
      details: {
        color: {
          color: "#1e293b",
          hsv: { h: 215, s: 54, v: 23 },
          alpha: 100,
          open: "false",
        },
        family: "'Plus Jakarta Sans'",
        size: 14,
      },
      headLine: {
        color: { color: "#ffffff", hsv: { h: 0, s: 0, v: 100 }, alpha: 100 },
        size: 48,
        family: "'Playfair Display'",
      },
      preEntryMessage: {
        size: 28,
        family: "'Plus Jakarta Sans'",
        color: { color: "#f8fafc", hsv: { h: 220, s: 3, v: 99 }, alpha: 100 },
      },
      detailsHeading: {
        size: 24,
        family: "'Plus Jakarta Sans'",
        color: { color: "#1e293b", hsv: { h: 215, s: 54, v: 23 }, alpha: 100 },
      },
      entryButtonText: {
        color: {
          color: "#FFFFFF",
          hsv: { h: 0, s: 0, v: 100 },
          alpha: 100,
          open: "false",
        },
        family: "'Plus Jakarta Sans'",
        size: 16,
        weight: 700,
      },
      entryButtonColor: {
        color: {
          color: "#8b5cf6",
          hsv: { h: 258, s: 62, v: 96 },
          alpha: 100,
          open: false,
        },
      },
      scrollButtonColor: {
        color: {
          color: "#8b5cf6",
          hsv: { h: 258, s: 62, v: 96 },
          alpha: 100,
          open: false,
        },
      },
      scrollButtonTextColor: {
        color: {
          color: "#ffffff",
          hsv: { h: 0, s: 0, v: 100 },
          alpha: 100,
          open: false,
        },
      },
      formTextColor: { color: { color: "#1e293b", alpha: 100, open: false } },
      formContainerColor: {
        color: { color: "#e2e8f0", alpha: 100, open: false },
      },
      formLabelColor: {
        color: { color: "#64748b", alpha: 100, open: false },
      },
      smsOptinButtonColor: {
        color: {
          color: "#8b5cf6",
        },
      },
      smsOptinBackgroundColor: {
        color: {
          color: "#f5f3ff",
        },
      },
      smsOptinHeadlineColor: {
        color: {
          color: "#6d28d9",
        },
      },
      smsOptinTextColor: {
        color: {
          color: "#1e293b",
        },
      },
    },
    imagePos: { zoom: 50, x: 50, y: 50 },
    imagePosMobile: { zoom: 50, x: 50, y: 50 },
    overlay: {
      type: "gradient",
      color1: "#1e1b4b",
      opacity1: 0.75,
      color2: "#312e81",
      opacity2: 0.85,
    },
    form: {
      color: "#ffffff",
      opacity: 1,
      backdropBlur: 0,
      borderRadius: 16,
      shadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    },
    gradientLeftDesk: 1,
    gradientLeftMobile: 1,
    gradientRightDesk: 0.3,
    gradientRightMobile: 0.3,
  },
};
